import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, ElementRef, effect, input, output, viewChild } from '@angular/core';
import { ButtonComponent } from '@cue/assist/ui/buttons';
import { translation } from '@cue/translations';
import { cueAdd } from '@cue/ui/icons';
import { TooltipDirective } from '@cue/ui/tooltips';
import { TranslocoPipe } from '@jsverse/transloco';
import { NewReservationResourcePickerItem } from '../new-reservation-dialog.models';

@Component({
  selector: 'assist-new-reservation-location-picker',
  templateUrl: './new-reservation-location-picker.component.html',
  styleUrl: './new-reservation-location-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, OverlayModule, TooltipDirective, TranslocoPipe],
})
export class NewReservationLocationPickerComponent {
  readonly active = input.required<boolean>();
  readonly items = input.required<NewReservationResourcePickerItem[]>();
  readonly loading = input(false);
  readonly searchValue = input.required<string>();

  readonly addLocation = output<void>();
  readonly closePicker = output<void>();
  readonly resourceSelected = output<NewReservationResourcePickerItem>();
  readonly searchChange = output<string>();
  readonly scrollEnd = output<void>();

  readonly icons = {
    cueAdd,
  };
  readonly translation = translation;

  readonly resourcePickerPositions: ConnectedPosition[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
  ];

  private readonly resourcePickerSearchInputElement = viewChild<ElementRef<HTMLInputElement>>(
    'resourcePickerSearchInputElement'
  );

  private readonly focusSearchInputWhenActive = effect(() => {
    if (!this.active()) {
      return;
    }

    queueMicrotask(() => this.resourcePickerSearchInputElement()?.nativeElement.focus());
  });

  onAddLocation(event: Event) {
    event.preventDefault();
    this.addLocation.emit();
  }

  onResourcePickerFilterChange(value: string) {
    this.searchChange.emit(value ?? '');
  }

  onResourcePickerScroll(event: Event) {
    const element = event.target as HTMLElement;
    const nearBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 48;

    if (nearBottom) {
      this.scrollEnd.emit();
    }
  }
}
